const ICONS_BASE_PATH = '/assets/icons';

export const natural100Icon = `${ICONS_BASE_PATH}/100_natural.png`;
export const antiBactariaIcon = `${ICONS_BASE_PATH}/anti_bactaria.png`;
export const authenticIcon = `${ICONS_BASE_PATH}/Authentic.png`;
export const bioDegradableIcon = `${ICONS_BASE_PATH}/bio_degradable.png`;
export const chlorineFreeIcon = `${ICONS_BASE_PATH}/chlorine_free.png`;
export const syntheticFragranceCollectionIcon = `${ICONS_BASE_PATH}/collection-six-circular-stamps-indicating-600nw-2706051219.jpg`;
export const dedicatedSupportIcon = `${ICONS_BASE_PATH}/Dedicated_Support.png`;
export const ecoFriendlyIcon = `${ICONS_BASE_PATH}/eco-friendly.png`;
export const fssaiIcon = `${ICONS_BASE_PATH}/FSSAI.png`;
export const gmpCertifiedIcon = `${ICONS_BASE_PATH}/gmp_certified_png_400x.png`;
export const iafIcon = `${ICONS_BASE_PATH}/iaf.png`;
export const iso2015Icon = `${ICONS_BASE_PATH}/iso2015.png`;
export const killGermsIcon = `${ICONS_BASE_PATH}/kill_germs.png`;
export const noMushroomIcon = `${ICONS_BASE_PATH}/no-mushroom.png`;
export const noAddedSoapIcon = `${ICONS_BASE_PATH}/no_added_soap.png`;
export const noAddedSyntheticColorIcon = `${ICONS_BASE_PATH}/no_added_synthetic_color.png`;
export const noFragranceIcon = `${ICONS_BASE_PATH}/no_fragrance.png`;
export const noGreenwashingIcon = `${ICONS_BASE_PATH}/No_Greenwashing.png`;
export const noHarshChemicalsIcon = `${ICONS_BASE_PATH}/no_harsh_chemicals.png`;
export const planetFriendlyIcon = `${ICONS_BASE_PATH}/planet_friendly.png`;
export const preservativesFreeIcon = `${ICONS_BASE_PATH}/preservatives-free-natural-organic-food-package-label-no-additives-no-preservatives-natural-food-vector-illustration_565585-7999.png`;
export const skinFriendlyIcon = `${ICONS_BASE_PATH}/skin_friendly.png`;
export const soapFreeIcon = `${ICONS_BASE_PATH}/soap_free.png`;
export const transparentIcon = `${ICONS_BASE_PATH}/Transparent.png`;
export const labTestedIcon = `${ICONS_BASE_PATH}/lab_tested.png`;
export const clinicallyProvenIcon = `${ICONS_BASE_PATH}/clinically_proven.png`;
export const doNotUseOnCutProductIcon = `${ICONS_BASE_PATH}/do_not_use_on_cut.png`;
export const madeInIndiaIcon = `${ICONS_BASE_PATH}/made_in_india.png`;
export const nonToxicIcon = `${ICONS_BASE_PATH}/non_toxic.jpg`;

export const iconAssets = {
  natural100: natural100Icon,
  antiBactaria: antiBactariaIcon,
  authentic: authenticIcon,
  bioDegradable: bioDegradableIcon,
  chlorineFree: chlorineFreeIcon,
  syntheticFragranceCollection: syntheticFragranceCollectionIcon,
  dedicatedSupport: dedicatedSupportIcon,
  ecoFriendly: ecoFriendlyIcon,
  fssai: fssaiIcon,
  gmpCertified: gmpCertifiedIcon,
  iaf: iafIcon,
  iso2015: iso2015Icon,
  killGerms: killGermsIcon,
  noMushroom: noMushroomIcon,
  noAddedSoap: noAddedSoapIcon,
  noAddedSyntheticColor: noAddedSyntheticColorIcon,
  noFragrance: noFragranceIcon,
  noGreenwashing: noGreenwashingIcon,
  noHarshChemicals: noHarshChemicalsIcon,
  planetFriendly: planetFriendlyIcon,
  preservativesFree: preservativesFreeIcon,
  skinFriendly: skinFriendlyIcon,
  soapFree: soapFreeIcon,
  transparent: transparentIcon,
  labTested: labTestedIcon,
  clinicallyProven: clinicallyProvenIcon,
  doNotUseOnCut: doNotUseOnCutProductIcon,
  madeInIndia: madeInIndiaIcon,
  nonToxic: nonToxicIcon
} as const;

export type IconAssetKey = keyof typeof iconAssets;

export default iconAssets;
